<simple-header (action)="headerAction()" [actions]="headerActions" title="Estado de la luminaria" icon="close"></simple-header>
<gallery-list [readOnly]="readOnly" [(photos)]="photos" [maxPhotos]="3"></gallery-list>
<div class="align-center padding-top-8">
  <button mat-raised-button color="primary" (click)="confirm()" class="button-size-200">Aceptar</button>
</div>
